// Generated by deployment script - do not edit manually
const CONFIG = {
  region: "us-west-2",
  userPoolId: "us-west-2_WvCKSsOa4",
  userPoolClientId: "55co0sbiabhlg6r7cbk1oddu0j",
  apiUrl: "https://5t32cr4g5g.execute-api.us-west-2.amazonaws.com/prod/",
  cognitoDomain: "usage-tracking-v2-175373004006",
  midwayEnabled: true,
};

export default CONFIG;
